import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import TextField from '@material-ui/core/TextField';
import RaisedButton from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import { inject, observer } from 'mobx-react';
import { createComponent as cc } from 'react-fela';
import { CircularProgress } from '@material-ui/core';

const GridWrapper = cc(
  () => ({
    height: '100%',
  }),
  Grid,
  ['container', 'justify', 'direction', 'alignItems'],
);

const PaperWrapper = cc(
  () => ({
    padding: '24px',
  }),
  Paper,
  ['elevation'],
);

@withRouter
@inject('store')
@observer
class Login extends Component {
  constructor(props) {
    super(props);
    this.loginStore = this.props.store.loginStore;
    this.apiStore = this.props.store.apiStore;
    this.classes = props.classes;
  }

  handleFormSubmit = (event) => {
    event.preventDefault();
    if (!this.loginStore.isLoading) {
      this.loginStore.setIsLoading(true);
      this.apiStore
        .loginApi(this.loginStore.email, this.loginStore.password)
        .then(() => {
          this.loginStore.resetLoginStore();
          this.props.history.replace('/');
        })
        .catch((e) => {
          this.loginStore.setIsLoading(false);
          this.loginStore.setErrorMessage(e.message);
        });
    }
  };

  handleEmailChange = (event) => {
    this.loginStore.setEmail(event.target.value);
  };

  handlePasswordChange = (event) => {
    this.loginStore.setPassword(event.target.value);
  };

  renderLoginForm = (email, password, canLogin, error) => (
    <Grid item xs={10} md={6}>
      <PaperWrapper elevation={1}>
        <form onSubmit={this.handleFormSubmit}>
          <TextField
            id="name"
            label="email"
            type="email"
            fullWidth
            onChange={this.handleEmailChange}
            value={email}
          />

          <TextField
            id="password"
            label="password"
            type="password"
            fullWidth
            onChange={this.handlePasswordChange}
            value={password}
          />

          <RaisedButton
            type="submit"
            fullWidth
            variant="raised"
            color="primary"
            disabled={!canLogin}
          >
            Login
          </RaisedButton>

          <p>{error}</p>
        </form>
      </PaperWrapper>
    </Grid>
  );

  render() {
    const {
      email, password, canLogin, error, isLoading,
    } = this.loginStore;

    return (
      <GridWrapper
        container
        justify="center"
        alignItems="center"
        direction="row"
      >
        {!isLoading ? (
          this.renderLoginForm(email, password, canLogin, error)
        ) : (
          <Grid item>
            <CircularProgress size={68} />
          </Grid>
        )}
      </GridWrapper>
    );
  }
}

export default Login;



// WEBPACK FOOTER //
// ./src/routes/login/index.js